import React, { useState } from "react";
import tw from "twin.macro";
// import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line

// Assuming your Tailwind config has a 'primary' color defined,
// or adjust tw`bg-primary-500` to tw`bg-blue-500` etc. if using default colors.
// Make sure primary-500 is the blue you want.

const PageContainer = tw.div`
  py-12 mt-8
`;

const ContentWrapper = tw.div`
  container mx-auto px-6 sm:px-12 max-w-screen-lg
`;

const Section = tw.section`
  mt-12 first:mt-0 /* Add margin top, but none for the first section */
`;

const SectionTagline = tw.p`
  text-primary-500 text-xs font-bold uppercase tracking-wider mb-2
`;

const SectionHeading = tw.h2`
  text-3xl sm:text-4xl font-black text-gray-800 leading-tight mb-8
`;

const FormGrid = tw.div`
  grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-6
`;

const InputFieldWrapper = tw.div`
  flex flex-col
`;

const Label = tw.label`
  text-gray-700 text-sm font-semibold mb-2
`;

const Input = tw.input`
  px-4 py-3 bg-gray-200 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500
  text-gray-800 placeholder-gray-500
`;

const Select = tw.select`
  px-4 py-3 bg-gray-200 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500
  text-gray-800 appearance-none /* Remove default arrow */
  pr-8 /* Add padding for custom arrow */
  bg-no-repeat bg-center /* Position custom arrow */
`;

const SubmitButton = tw.button`
  mt-8 !bg-primary-500 text-white px-8 py-3 rounded-md hover:bg-primary-600 transition duration-300 focus:outline-none focus:ring-2 focus:ring-primary-500
  w-full sm:w-auto /* Full width on small, auto width on larger */
`;

export default () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  let formData = {};

  const handleFormSubmit = async (e) => {
    setIsSubmitting(true);
    e.preventDefault();
    for (let i = 0; i < e.target.length; i++) {
      formData[e.target[i].name] = e.target[i].value;

      if (i === e.target.length - 1) {
        fetch("https://tgnsystems.org/api/wealthwise/apply-loan", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => {
            setIsSubmitting(false);
            console.log("response", response);
            if (response.status === 200) {
              alert("Message sent successfully!");
              e.target.reset();
            } else {
              alert("Failed to send message. Please try again.");
            }
          })
          .catch((error) => {
            console.error("Error:", error.response);
            setIsSubmitting(false);
            alert("Message sent successfully!");
            e.target.reset();
          });
      }
    }
  };
  return (
    <PageContainer id="apply-loan">
      <ContentWrapper>
        {/* Loan Details Section */}
        <form onSubmit={handleFormSubmit}>
          <Section>
            <SectionTagline>|| Get yourself a quickloan ||</SectionTagline>
            <SectionHeading>Loan Details</SectionHeading>
            <FormGrid>
              <InputFieldWrapper>
                <Label htmlFor="loanAmount">Loan Amount*</Label>
                <Input
                  type="number"
                  id="loanAmount"
                  placeholder="Loan Amount"
                  name="loanAmount"
                  required
                />
              </InputFieldWrapper>
              <InputFieldWrapper>
                <Label htmlFor="monthlyIncome">Monthly Income*</Label>
                <Input
                  type="number"
                  id="monthlyIncome"
                  placeholder="Monthly Income"
                  name="monthlyIncome"
                  required
                />
              </InputFieldWrapper>
              <InputFieldWrapper>
                <Label htmlFor="purposeOfLoan">Purpose of Loan</Label>
                <Select
                  id="purposeOfLoan"
                  name="purposeOfLoan"
                  required
                  defaultValue=""
                >
                  {" "}
                  {/* Added defaultValue="" to show placeholder */}
                  <option value="" disabled hidden>
                    Select Purpose of Loan
                  </option>
                  <option value="emergency">Emergency Loan</option>
                  <option value="business">Business Loan</option>
                  <option value="schoolFees">School Fees Loan</option>
                  <option value="business">Asset Loan</option>
                </Select>
              </InputFieldWrapper>
              <InputFieldWrapper>
                <Label htmlFor="loanPeriod">Loan Period</Label>
                <Select
                  name="loanPeriod"
                  required
                  id="loanPeriod"
                  defaultValue=""
                >
                  <option value="" disabled hidden>
                    Select Loan Period
                  </option>
                  <option key={"1 Month"} value={"1 Month"}>
                    1 Month
                  </option>
                  <option key={"2 Month"} value={"2 Month"}>
                    2 Month
                  </option>
                  <option key={"3 Month"} value={"3 Month"}>
                    3 Month
                  </option>
                  <option key={"4 Month"} value={"4 Month"}>
                    4 Month
                  </option>
                  <option key={"5 Month"} value={"5 Month"}>
                    5 Month
                  </option>
                  <option key={"6 Month"} value={"6 Month"}>
                    6 Month
                  </option>
                  <option key={"7 Month"} value={"7 Month"}>
                    7 Month
                  </option>
                  <option key={"7 Month"} value={"7 Month"}>
                    8 Month
                  </option>
                  <option key={"7 Month"} value={"7 Month"}>
                    9 Month
                  </option>
                  <option key={"7 Month"} value={"7 Month"}>
                    10 Month
                  </option>
                  <option key={"7 Month"} value={"7 Month"}>
                    11 Month
                  </option>
                  <option key={"7 Month"} value={"7 Month"}>
                    1 year
                  </option>
                  <option key={"7 Month"} value={"7 Month"}>
                    2 years
                  </option>
                </Select>
              </InputFieldWrapper>
            </FormGrid>
          </Section>

          {/* Personal Details Section */}
          <Section>
            {/*  <SectionTagline>|| ASK FOR MORE DETAILS ||</SectionTagline> */}
            <SectionHeading>Personal Details</SectionHeading>
            <FormGrid>
              <InputFieldWrapper>
                <Label htmlFor="fullName">Full Name*</Label>
                <Input
                  type="text"
                  id="fullName"
                  name="fullName"
                  placeholder="Full Name"
                  required
                />
              </InputFieldWrapper>
              <InputFieldWrapper>
                <Label htmlFor="email">Email*</Label>
                <Input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Your Email"
                  required
                />
              </InputFieldWrapper>
              <InputFieldWrapper>
                <Label htmlFor="mobileNumber">Mobile Number*</Label>
                <Input
                  type="tel"
                  id="mobileNumber"
                  name="mobileNumber"
                  placeholder="Mobile Number"
                  required
                />{" "}
                {/* Using type="tel" */}
              </InputFieldWrapper>
              <InputFieldWrapper>
                <Label htmlFor="maritalStatus">Marital Status*</Label>
                <Select
                  id="maritalStatus"
                  name="maritalStatus"
                  defaultValue=""
                  required
                >
                  {" "}
                  {/* Added required */}
                  <option value="" disabled hidden>
                    Select Martial Status
                  </option>{" "}
                  <option value="single">Single</option>
                  <option value="married">Married</option>
                  <option value="divorced">Divorced</option>
                  <option value="widowed">Widowed</option>
                </Select>
              </InputFieldWrapper>
              <InputFieldWrapper>
                <Label htmlFor="birthDate">Birth Date*</Label>
                <Input
                  type="date"
                  id="dateOfBirth"
                  placeholder="Birth Date"
                  name="dateOfBirth"
                  required
                />{" "}
                {/* Using type="date" */}
              </InputFieldWrapper>
              <InputFieldWrapper>
                <Label htmlFor="nationalId">Nation ID Number*</Label>
                <Input
                  type="text"
                  id="nationalIdNumber"
                  name="nationalIdNumberr"
                  placeholder="National ID Number"
                  required
                />
              </InputFieldWrapper>
            </FormGrid>
          </Section>

          <Section>
            {/* <SectionTagline>|| OTHER DETAILS ||</SectionTagline> 
            <SectionHeading>Other Details</SectionHeading> */}
            <FormGrid>
              <InputFieldWrapper>
                <Label htmlFor="address">Home Address*</Label>
                <Input
                  type="text"
                  id="address"
                  placeholder="Address"
                  name="address"
                  required
                />
              </InputFieldWrapper>
              <InputFieldWrapper>
                <Label htmlFor="employmentStatus">Employment Status*</Label>
                <Select
                  name="employmentStatus"
                  id="employmentStatus"
                  defaultValue=""
                  required
                >
                  {" "}
                  {/* Added required */}
                  <option value="" disabled hidden>
                    Select Employer Status
                  </option>
                  <option value="employed">Employed</option>
                  <option value="self-employed">Self-Employed</option>
                  <option value="unemployed">Unemployed</option>
                  <option value="student">Student</option>
                  <option value="retired">Retired</option>
                </Select>
              </InputFieldWrapper>
            </FormGrid>
          </Section>
          <SubmitButton type="submit">
            {isSubmitting ? "Submitting..." : "Submit"}
          </SubmitButton>
        </form>
      </ContentWrapper>
    </PageContainer>
  );
};
